import React, { useState, useEffect } from 'react';
import { lunchboxService } from '../../lib/services/lunchbox';

const AddRecordModal = ({ date, classList, onAddRecord, onClose }) => {
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedStudent, setSelectedStudent] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);

  const lunchboxTypes = [
    { type: 'A', name: '家常風味', color: 'orange', icon: '🍳' },
    { type: 'B', name: '特式風味', color: 'blue', icon: '🍽️' },
    { type: 'C', name: '至營推介', color: 'red', icon: '❤️' },
    { type: 'D', name: '健康素食', color: 'green', icon: '🌱' }
  ];

  const loadStudents = React.useCallback(async () => {
    try {
      setLoading(true);
      const allStudents = await lunchboxService.getStudents();
      const classStudents = allStudents.filter(student => student.class_id === selectedClass);
      setStudents(classStudents);
    } catch (error) {
      console.error('Error loading students:', error);
      setStudents([]);
    } finally {
      setLoading(false);
    }
  }, [selectedClass]);

  useEffect(() => {
    if (selectedClass) {
      loadStudents(selectedClass);
    } else {
      setStudents([]);
      setSelectedStudent('');
    }
  }, [selectedClass, loadStudents]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedClass || !selectedStudent || !selectedType) {
      alert('請填寫所有欄位');
      return;
    }

    const student = students.find(s => s.id === selectedStudent);
    if (!student) {
      alert('找不到選中的學生');
      return;
    }

    onAddRecord({
      studentId: selectedStudent,
      studentName: student.student_name,
      classId: selectedClass,
      lunchboxType: selectedType
    });
  };

  const formatDate = (date) => {
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>新增飯盒記錄</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          <div className="date-info">
            <p><strong>日期:</strong> {formatDate(date)}</p>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>班級:</label>
              <select 
                value={selectedClass} 
                onChange={(e) => setSelectedClass(e.target.value)}
                required
              >
                <option value="">請選擇班級</option>
                {classList.map(classId => (
                  <option key={classId} value={classId}>{classId}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>學生:</label>
              <select 
                value={selectedStudent} 
                onChange={(e) => setSelectedStudent(e.target.value)}
                required
                disabled={!selectedClass || loading}
              >
                <option value="">請選擇學生</option>
                {students.map(student => (
                  <option key={student.id} value={student.id}>
                    {student.student_id} - {student.student_name}
                  </option>
                ))}
              </select>
              {loading && <div className="loading-text">載入學生中...</div>}
            </div>

            <div className="form-group">
              <label>飯盒類型:</label>
              <div className="lunchbox-type-selector">
                {lunchboxTypes.map(type => (
                  <label key={type.type} className={`type-option ${type.color} ${selectedType === type.type ? 'selected' : ''}`}>
                    <input
                      type="radio"
                      name="lunchboxType"
                      value={type.type}
                      checked={selectedType === type.type}
                      onChange={(e) => setSelectedType(e.target.value)}
                    />
                    <span className="type-icon">{type.icon}</span>
                    <span className="type-label">
                      {type.type} - {type.name}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={onClose}>
                取消
              </button>
              <button type="submit" className="btn-primary">
                新增記錄
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddRecordModal;
